<div class="row px-0 mx-0 align-items-center">
  <p>{{input.MainElementList[0].SelectOptionsList[2].Text}}</p>
  <input class="ml-2 switch" [ngClass]="[ input.MainElementList[0].Value === '3'? 'rigth' :  input.MainElementList[0].Value === '2'? 'middle' : 'left']" [attr.type]="input.MainElementList[0].Type" [id]="input.MainElementList[0].ID" name="points" min="1" max="3" [(ngModel)]="input.MainElementList[0].Value">
  <p class="ml-2">{{input.MainElementList[0].SelectOptionsList[3].Text}}</p>
</div>
